module.exports = __webpack_public_path__ + "static/media/map.07aad4fb.svg";